export default __webpack_public_path__ + "static/media/bg.feb68631.png";